import { ListResource, UnpagedListResource, createApiResource } from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import { ServiceTitanJobQueryParams, ServiceTitanJob } from '../apiTypes.shim';

interface ServiceTitanJobResource
  extends UnpagedListResource<ServiceTitanJob, ServiceTitanJobQueryParams>,
    ListResource<ServiceTitanJob, ServiceTitanJobQueryParams> {}

export const createServiceTitanJobResource = (companyId: string): ServiceTitanJobResource => {
  const jobResourceUri = `${companyId}/jobs`;

  const { list, useList, useUnpagedList, unpagedList, listQueryKey, unpagedListQueryKey } = createApiResource(
    ServiceTitanAPI,
    jobResourceUri
  );
  return {
    list,
    useList,
    useUnpagedList,
    unpagedList,
    listQueryKey,
    unpagedListQueryKey
  };
};
